import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUser, 
  faEnvelope, 
  faUsers,
  faUserFriends
} from '@fortawesome/free-solid-svg-icons';
import { ApplicationStatus } from '../../services/applicationService';
import '../../styles/ApplicationSummary.css';

interface ApplicationSummaryProps {
  application: ApplicationStatus;
}

const ApplicationSummary: React.FC<ApplicationSummaryProps> = ({ application }) => {
  return (
    <div className="application-summary">
      <h3>
        <FontAwesomeIcon icon={faUser} className="summary-section-icon" />
        Application Summary
      </h3>
      <div className="summary-details">
        <div className="summary-row">
          <div className="label">
            <FontAwesomeIcon icon={faUser} className="summary-icon" />
            <span>Name/Alias:</span>
          </div>
          <div className="value">{application.name}</div>
        </div>
        
        <div className="summary-row">
          <div className="label">
            <FontAwesomeIcon icon={faEnvelope} className="summary-icon" />
            <span>Email:</span>
          </div>
          <div className="value">{application.email}</div>
        </div>
        
        <div className="summary-row">
          <div className="label">
            {application.attendeeType === 'single' ? (
              <FontAwesomeIcon icon={faUser} className="summary-icon" />
            ) : (
              <FontAwesomeIcon icon={faUserFriends} className="summary-icon" />
            )}
            <span>Attendee Type:</span>
          </div>
          <div className="value">
            {application.attendeeType === 'single' ? 'Single Attendee' : 'Couple'}
          </div>
        </div>
        
        {application.attendeeType === 'couple' && (
          <div className="summary-row">
            <div className="label">
              <FontAwesomeIcon icon={faUsers} className="summary-icon" />
              <span>Partner Information:</span>
            </div>
            <div className="value">
              {/* Partner information display would ideally come from the application object */}
              {/* Since it's not available in the ApplicationStatus type, we show a placeholder */}
              <span className="secondary-text">View partner details in full application</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApplicationSummary;
